export const textShorter = (text: string = "", limited: number = 10) => {
  return text && text.length > limited
    ? `${text.substring(0, limited)}...`
    : text;
};

export const textCutter = (text = "", limited = 4) => {
  return text && text.length > limited ? text.substring(0, limited) : text;
};

// a little function to help us with reordering the result
export const reOrderList = (
  list: any[],
  startIndex: number,
  endIndex: number,
) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const formSubmitter = (
  action: any,
  params?: Record<string, string>,
  method = "post",
) => {
  const form = document.createElement("form");
  form.method = method;
  form.action = action;
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];
      form.appendChild(hiddenField);
    }
  }
  document.body.appendChild(form);
  form.submit();
};

export const bytesToSize = (bytes: any) => {
  // 20025 >> 20KB
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  // @ts-ignore
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  // @ts-ignore
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

export const downloadFile = (fileUrl: string, fileName: string) => {
  window.open(fileUrl, fileName);
};

export const getMaxPageOffset = () => {
  return Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
  );
};

export const scrollToPoint = (point?: number) =>
  window.scrollTo(0, point || document.body.scrollHeight);

export const sortByPosition = (a: any, b: any) => {
  if (typeof a.Position !== "number" || typeof b.Position !== "number")
    return 1;

  return a.Position - b.Position;
};

export const sortByOrder = (a: any, b: any) => {
  if (!a.Order || !b.Order) return 1;

  return a.Order - b.Order;
};

export const ordinalNumber = (number: number) => {
  // number begin 1, 2, 3, ...
  const ordinalArr = [
    "اول",
    "دوم",
    "سوم",
    "چهارم",
    "پنجم",
    "ششم",
    "هفتم",
    "هشتم",
    "نهم",
    "دهم",
  ];
  if (+number < 0) return;
  return +number > 10 ? number + "ام" : ordinalArr[+number - 1];
};

export const noop = () => {};

export function on<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args: Parameters<T["addEventListener"]> | [string, Function | null, ...any]
): void {
  if (obj && obj.addEventListener) {
    obj.addEventListener(
      ...(args as Parameters<HTMLElement["addEventListener"]>),
    );
  }
}

export function off<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args:
    | Parameters<T["removeEventListener"]>
    | [string, Function | null, ...any]
): void {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(
      ...(args as Parameters<HTMLElement["removeEventListener"]>),
    );
  }
}

export const isBrowser = typeof window !== "undefined";

export const isNavigator = typeof navigator !== "undefined";
